import React from "react";

const NotificationBell = ({ size, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.64887 13.7216C9.86391 8.99062 13.9264 5.14771 18.6477 5.14771C23.369 5.14771 27.4315 8.99063 27.6465 13.7216C27.6473 13.7386 27.6477 13.7557 27.6477 13.7727V19.3977C27.6477 21.2467 28.15 22.9353 29.0061 24.4764C29.1997 24.8248 29.1945 25.2497 28.9923 25.5932C28.7902 25.9368 28.4213 26.1477 28.0227 26.1477H9.27271C8.8741 26.1477 8.50525 25.9368 8.3031 25.5932C8.10095 25.2497 8.0957 24.8248 8.28928 24.4764C9.1454 22.9353 9.64771 21.2467 9.64771 19.3977V13.7727C9.64771 13.7557 9.64809 13.7386 9.64887 13.7216ZM11.8977 13.7993V19.3977C11.8977 21.0064 11.5866 22.5079 11.0444 23.8977H26.251C25.7088 22.5079 25.3977 21.0064 25.3977 19.3977V13.7993C25.2247 10.2913 22.1682 7.39771 18.6477 7.39771C15.1272 7.39771 12.0707 10.2913 11.8977 13.7993ZM17.1477 27.2727C17.1477 28.1011 17.8193 28.7727 18.6477 28.7727C19.4761 28.7727 20.1477 28.1011 20.1477 27.2727H22.3977C22.3977 29.3438 20.7188 31.0227 18.6477 31.0227C16.5766 31.0227 14.8977 29.3438 14.8977 27.2727H17.1477Z"
      fill="currentColor"
    />
  </svg>
);

export default NotificationBell;
